export const GreyBrandColor = "#454545"; // 454545 | 606060
export const BlueBrandColor = "#3e92cc"; // 3e92cc | 78c0e0
export const RedBrandColor = "ed474a";
export const WhiteBrandColor = "fffffe";
export const GreenBrandColor = "0cce6b";

export const DefaultContainerStyle = { background: "#FFFFFE", textAlign: "center" };
